import common from "../../common";

function ShopNavigationPanel() {
  if (common.isMobileScreen()) {
    return <div></div>;
  }
  return (
    <div>
      <div className="col-md-12 col-sm-6">
        <div className="product-sidebar-category-item">
          <h6 className="product-sidebar-category-item-title">
            Shop by category
          </h6>
          {/* iterate through common.productTypeDisplayNames and display names and links */}
          <ul className="product-sidebar-category-item-list rd-navbar-nav">
            {Object.keys(common.productTypeURL).map((type) => (
              <li
                className="rd-nav-item active"
                key={common.productTypeURL[type]}
              >
                <a
                  className="rd-nav-link"
                  href={"/products/" + common.productTypeURL[type]}
                >
                  {common.productTypeDisplayNames[type]}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default ShopNavigationPanel;
